import { permis_conduire } from './permis-conduire.js';
import { carte_grise } from './carte-grise.js';
import { attestation_assurance } from './attestation-assurance.js';
import { carte_carburant } from './carte-carburant.js';

export const SCAN_CONFIGS = {
  permis_conduire,
  carte_grise,
  attestation_assurance,
  carte_carburant,
};
